



























import { Component, Prop, Vue } from "vue-property-decorator";
import CFMGridPage from "@/scripts/CFMGridPage";
import { CFMModelWorkOrderFailureModeView } from "@/scripts/services/ClientApiAuto";
import { mixinz } from "@/scripts/global/mixinz";
import * as blockui from '@/helpers/block-ui'
import moment from 'moment';
import * as swal from '@/helpers/swal'
import { DataStateChangeEventArgs } from "@syncfusion/ej2-vue-grids";
import { Predicate } from '@syncfusion/ej2-data';
import * as dateFormat from '@/helpers/dateFormat';

@Component<FailureModeGrid>({
    mixins: [mixinz],
})
export default class FailureModeGrid extends CFMGridPage<CFMModelWorkOrderFailureModeView> {
    @Prop({ required: true }) workOrderId!: string;

    entityType = "Failure";

    sorts: { field: string, direction: string }[] = [
        { field: "WorkOrderId", direction: "Ascending" }
    ];

    gridDataSource: any[] = [];

    gridSparePartProps: any = {
        ref: 'grid',
        allowPaging: true,
        allowFiltering: true,
        allowSorting: true,
        allowGrouping: false,
        allowResizing: true,
        allowExcelExport: false,
        allowPdfExport: false,
        allowCsvExport: false,
    }

    entityState: DataStateChangeEventArgs = {
        where: [
            new Predicate('WorkOrderId', 'equal', this.workOrderId, false)
        ]
    };

    async created() {
        this.filterSettings = { type: 'Menu' };
        this.createdHook();
        await this.$nextTick();
        this.dataStateChange(this.state);
    }

    async mounted() {
        this.$eventHub.$on('failureModeAdded', this.refreshGrid);
    }

    beforeDestroy() {
        this.$eventHub.$off('failureModeAdded', this.refreshGrid);
    }

    refreshGrid() {
        this.createdHook();
        this.dataStateChange(this.state);
    }

    convertToDay(field: any, data: any, column: any) {
        return dateFormat.formatMinute(data[field], this);
    }

    editTemplate() {
        const self = this;
        const methods = {
            editRecord(data: CFMModelWorkOrderFailureModeView) {
                self.$eventHub.$emit('editFailureMode', { id: data.Id, workOrderId: data.WorkOrderId });
            }
        };
        return {
            template: Vue.component('editColumnTemplate', {
                template: `<button @click="editRecord(data)" class="btn btn-sm btn-primary">
                    <i class="la la-edit"></i>
                  </button>`,
                methods: methods,
            }),
        };
    }

    deleteTemplate() {
        const self = this;
        const methods = {
            async deleteRecord(data: CFMModelWorkOrderFailureModeView) {
                const e = await swal.check(self, data.DeviceName);
                if (!e.value) return;
                try {
                    blockui.pageBlock(self);
                    const response = await self.apiClient.failure.failureDelete({ id: data.Id });
                    if (response.data.IsSuccess) {
                        toastr.success(self.translate('delete_successfully'));
                        self.refreshGrid();
                        self.$eventHub.$emit('reloadTabCounts', { workOrderId: self.workOrderId });
                    } else {
                        toastr.error(response.data.Message || 'Error');
                    }
                } catch (error) {
                    console.error('Error deleting failure mode:', error);
                } finally {
                    blockui.unBlockPage();
                }
            }
        };
        return {
            template: Vue.component('deleteColumnTemplate', {
                template: `<button @click="deleteRecord(data)" class="btn btn-sm btn-danger">
                <i class="la la-trash"></i>
              </button>`,
                methods: methods,
            }),
        };
    }
}
